import { CSSProperties, useMemo } from "react";
import { buildAccentPalette } from "utils/accentPalette";
import { useStyles } from "./WorkspaceBrandingPreview.styles";
import { IWorkspaceBrandingPreviewProps } from "./WorkspaceBrandingPreview.types";

const DEFAULT_WORKSPACE_NAME = "Acme Digital Transformation";
const DEFAULT_CLIENT_NAME = "Project IQ";
const DEFAULT_LOGO_BADGE_TEXT = "NH";

export const WorkspaceBrandingPreview = ({
  headerColor,
  accentColor,
  headerLogoUrl,
  workspaceName = DEFAULT_WORKSPACE_NAME,
  clientName = DEFAULT_CLIENT_NAME,
}: IWorkspaceBrandingPreviewProps): JSX.Element => {
  const styles = useStyles();

  const accentPalette = useMemo(
    () => buildAccentPalette(accentColor, headerColor),
    [accentColor, headerColor],
  );

  const previewCssVariables = useMemo<CSSProperties>(
    () =>
      ({
        "--preview-sidebar-bg": accentPalette.headerBg,
        "--preview-header-text": accentPalette.headerText,
        "--preview-active-bg": accentPalette.accent,
        "--preview-active-text": accentPalette.accentText,
        "--preview-accent-on-white": accentPalette.accent,
        "--preview-accent-on-white-text": accentPalette.accentText,
      }) as CSSProperties,
    [accentPalette],
  );

  return (
    <div className={styles.outer} style={previewCssVariables}>
      <div className={styles.sidebar}>
        <div className={styles.logoRow}>
          {headerLogoUrl ? (
            <img src={headerLogoUrl} alt="" className={styles.logoImage} />
          ) : (
            <div className={styles.logoBadge} aria-hidden="true">
              {DEFAULT_LOGO_BADGE_TEXT}
            </div>
          )}
        </div>
        <span className={styles.appTitle}>{clientName}</span>
        <span className={styles.workspaceRow}>{workspaceName}</span>
      </div>
      <div className={styles.main}>
        <div className={styles.headerBar}>{workspaceName}</div>
        <div className={styles.card}>
          <div className={styles.cardTitle}>Status</div>
          <span className={styles.badge}>On Track</span>
        </div>
      </div>
    </div>
  );
};
